// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./resources/assets/less/app_black.less
// module id = ./resources/assets/less/app_black.less
// module chunks = 0